export default __webpack_public_path__ + "static/media/pushyy-new.53fa221a.png";